import { Checkbox, Form } from 'antd'
import { SharePointParentFolder } from 'shared'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import SharePointUploader from 'components/SharePointUploader'
import { CreateIssueFormItemsProps } from './types'
import CIMSTextArea from 'components/CIMSTextArea'
import { useValidateWhitespaceProps } from 'components/CIMSTextArea/hooks/useValidateWhitespaceProps'
import { useIssueReportsSelectOptionsContext } from '../../../../IssueReportsSelectOptionsContext'

const CreateIssueFormItems: React.FC<CreateIssueFormItemsProps> = ({
  number,
  types,
  loading,
}) => {
  const { selectProps } = useIssueReportsSelectOptionsContext()
  const help = HelpMessage.Issues.IssueTracker
  return (
    <>
      <Form.Item hidden name="submit" valuePropName="checked">
        <Checkbox />
      </Form.Item>
      <CIMSFormItem
        label="Types"
        name="issueTypes"
        requiredMessage="Please select at least one type"
        help={help.Types}
      >
        <CIMSSelect multiple loading={loading} options={types} />
      </CIMSFormItem>
      <CIMSFormItem
        name="description"
        help={help.Description}
        {...useValidateWhitespaceProps({ label: 'Description' })}
      >
        <CIMSTextArea maxLength={2000} />
      </CIMSFormItem>
      <CIMSFormItem label="Reports" name="reports" help={help.Reports}>
        <CIMSSelect {...selectProps} />
      </CIMSFormItem>
      <CIMSFormItem label="Pay Items" name="payItems" help={help.PayItems}>
        <PayItemSelect multiple />
      </CIMSFormItem>
      <SharePointUploader
        parent={SharePointParentFolder.Issues}
        folder={number}
        generic
      />
    </>
  )
}

export default CreateIssueFormItems
